// The backend normally generates a UUID v4. Its request ID middleware can
// also echo an arbitrary client header, so treat every response ID as untrusted.
// In particular, websocket credentials are 43-character URL-safe strings.
export function safeGitlabRequestId(value: unknown): string | undefined {
  return typeof value === 'string' &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(value)
    ? value
    : undefined;
}
